import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, hideErrorMessage, showSuccessMessage } from "./ui";
import { 
  checkBlockedPhone,
  checkVerificationPhone,
  unblockPhone
} from '../../request';
//Поиск
export const CHANGE_PHONES_SEARCH = "Change phones search";
export const START_PHONES_SEARCH = "Switch phones search";
export const CLEAR_PHONES_SEARCH = "Clear phones search";
export const CHECK_PHONE_FAILED = "Check phone failed";
export const CHECK_PHONE_SUCCESSFULLY = "Check phone successfully";
export const UNBLOCK_PHONE_FAILED = "Unblock phone failed";
export const UNBLOCK_PHONE_SUCCESSFULLY = "Unblock phone successfully";

const checkBlockPhoneFailure = (isBlocked) => ({
  type: CHECK_PHONE_FAILED,
  isBlocked: isBlocked,
});

const checkVerificationPhoneFailure = (isVerified) => ({
  type: CHECK_PHONE_FAILED,
  isVerified: isVerified,
});

const checkPhoneSuccess = (result) => ({
  type: CHECK_PHONE_SUCCESSFULLY,
  result: result
});

const unblockPhoneFailure = () => ({
  type: UNBLOCK_PHONE_FAILED,
})
const unblockPhoneSuccess = () => ({
  type: UNBLOCK_PHONE_SUCCESSFULLY,
});


export const checkBlockedPhoneAsync = payload => {
  return async (dispatch) => {
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    try {
      const accessToken = localStorage.getItem("accessToken");
      await checkBlockedPhone(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Телефон не найден!"));
      return dispatch(checkBlockPhoneFailure(true));
    }
    return dispatch(checkPhoneSuccess(true));
  };
};
export const checkVerificationPhoneAsync = payload => {
  return async (dispatch) => {
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    try {
      const accessToken = localStorage.getItem("accessToken");
      await checkVerificationPhone(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Телефон не найден!"));
      return dispatch(checkVerificationPhoneFailure(true));
    }
    return dispatch(checkPhoneSuccess(true));
  };
};

export const unblockPhoneAsync = payload => {
  return async (dispatch) => {
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    try {
      const accessToken = localStorage.getItem("accessToken");
      await unblockPhone(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при попытке разблокировать!"));
      return dispatch(unblockPhoneFailure());
    }
    dispatch(showSuccessMessage("Телефон разблокирован!"));
    return dispatch(unblockPhoneSuccess());
  }
}

//Поиск
export const changePhonesSearch = value => ({ 
    type: CHANGE_PHONES_SEARCH,
    payload: { value }
  });
  
  export const startPhonesSearch = value => ({
    type: START_PHONES_SEARCH,
    payload: { value }
  });
  
  export const clearPhonesSearch = () => ({
    type: CLEAR_PHONES_SEARCH,
  });